<template>
  <el-carousel ref="carouselRef" height="100vh" indicator-position="none" arrow="always" :interval="10000" @mouseenter.native="delHandleMouseEnter">
    <el-carousel-item ref="itemRef" v-for="item in swiperList" :key="item.resourceName">
<!--      <img style="width: 100%;height: 100%" :src="item.fileUrl" alt="">-->
      <video :src="item.fileUrl" style="cursor: default;width: 100%;height: 100%;object-fit: fill;pointer-events: none;" loop autoplay disablePictureInPicture muted="muted"></video>
<!--      <div class="title-wrapper">-->
<!--        <h1 class="home-title animate__animated animate__backInUp">{{ item.title }}</h1>-->
<!--      </div>-->
      <img class="arrow-down" :src="arrowDown" alt="" @click="$parent.jumpToDown">
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import key from "@/api/key";

export default {
  name: 'first-screen',
  data() {
    return {
      swiperTitleList: [
        'SPACE NARRATIVE',
        'DIGITAL INTERACTIVE',
        'CONNECT'
      ],
      swiperList: [],
      arrowDown: key.getByName(key.COMMON, 'arrow-down').fileUrl
    }
  },
  created() {
    this.$nextTick(() => {
      const swiperList = key.get(key.HOME_SWIPER_VIDEO)
      this.swiperList = swiperList.map((res, idx) => {
        res.title = this.swiperTitleList[idx]
        return res
      })
    })
  },
  mounted() {
    this.delHandleMouseEnter()
  },
  methods: {
    delHandleMouseEnter() {
      //Element UI走马灯Carousel取消鼠标悬停不自动切换
      this.$refs.carouselRef.handleMouseEnter = () => {
      }
    }
  }
}
</script>

<style scoped lang="scss">
.title-wrapper {
  width: 100vw;
  display: flex;
  justify-content: center;

  .home-title {
    position: absolute;
    top: 50%;
    color: #FFFFFF;
    font-size: 5vw;
    font-weight: bold;
    line-height: 5vw;
  }
}

.arrow-down {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  width: 4.5vw;
  height: 4.5vw;
  animation: bounce-in 1.5s linear infinite;
  cursor: pointer;
}

@keyframes bounce-in {
  25% {
    transform: translate(-50%, -5px);
  }
  50% {
    transform: translate(-50%, 0);
  }
  75% {
    transform: translate(-50%, 10px);
  }
  100% {
    transform: translate(-50%, 0);
  }
}
</style>
